import script from "./LibraryBookCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LibraryBookCard.vue?vue&type=script&setup=true&lang=js"

import "./LibraryBookCard.vue?vue&type=style&index=0&id=52efd1d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52efd1d6"]])

export default __exports__